// Standardized date formatting utilities
export const formatDate = (timestamp) => {
  if (!timestamp) return "Invalid Date";

  try {
    // Handle different timestamp formats
    let dateString = timestamp;

    // If timestamp has fractional seconds longer than milliseconds (e.g. Python microseconds),
    // trim to 3 digits while preserving timezone (e.g. "....401573+00:00" -> "....401+00:00").
    //
    // Old logic (kept for reference):
    // if (typeof timestamp === "string" && timestamp.includes(".")) {
    //   dateString = timestamp.slice(0, -3) + "Z";
    // }
    if (typeof timestamp === "string") {
      dateString = timestamp.replace(/(\.\d{3})\d+/, "$1");
    }

    const parsedDate = new Date(dateString);

    if (isNaN(parsedDate.getTime())) {
      return "Invalid Date";
    }

    return parsedDate.toLocaleString();
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid Date";
  }
};

export const formatRelativeDate = (timestamp) => {
  if (!timestamp) return "Unknown";

  try {
    // Use the same normalization logic as formatDate for microseconds/tz strings.
    const normalized = typeof timestamp === "string"
      ? timestamp.replace(/(\.\d{3})\d+/, "$1")
      : timestamp;
    const date = new Date(normalized);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) return "Just now";
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInDays < 7) return `${diffInDays}d ago`;

    return formatDate(timestamp);
  } catch (error) {
    return "Unknown";
  }
};
